import { useData } from '../../contexts/data-context/use-data';
import { Inline } from '../../design-system/inline/inline';
import { Select } from '../../design-system/select/select';
import { supportedCountryCurrencies, SupportedCountryCurrency } from '../../types/supported-country-currency';
import { getCurrencyFlag } from '../../utils/get-currency-flag';

export const CurrencySelector = () => {
  const { data, isLoading, mutations } = useData();

  if (!data || isLoading) {
    return null;
  }

  return (
    <Select placeholder="Select Currency" onValueChange={mutations.setBaseCurrency} value={data.baseCurrency}>
      {supportedCountryCurrencies.map((currency) => (
        <CurrencySelectorItem key={currency} currency={currency} />
      ))}
    </Select>
  );
};

type CurrencySelectorItemProps = {
  currency: SupportedCountryCurrency;
};

const CurrencySelectorItem = ({ currency }: CurrencySelectorItemProps) => {
  const currencyFlag = getCurrencyFlag(currency);

  return (
    <Select.Item value={currency} textValue={currency}>
      <Inline>
        <div className="h-4 w-4 overflow-clip rounded-full">
          <img src={currencyFlag} alt="" loading="eager" fetchPriority="high" className="h-full w-full" />
        </div>

        <p>{currency}</p>
      </Inline>
    </Select.Item>
  );
};
